import React from "react";
import classNames from "classnames";

import styles from "./Modal.module.css";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  const classes = classNames(styles["modal"], {
    [styles["open"]]: isOpen,
    [styles["closed"]]: !isOpen,
  });
  return (
    <div className={styles["backdrop"]} onClick={onClose}>
      <div className={classes} onClick={(e) => e.stopPropagation()}>
        <button className={styles["btn--close"]} onClick={onClose} aria-label="Close">
          ✕
        </button>
        <div className={styles["modal-content"]}>
          {title && <h2 className={styles["modal-title"]}>{title}</h2>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
